import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const LazyPlannerCopilotSidecarContainer = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "planner-copilotsidecar" */ "./PlannerCopilotSidecarContainer")).then((bundle)=>({
            default: bundle.PlannerCopilotSidecarContainer
        })));
